import { IPasswordStrengthIndicator } from '@poinz/hooks';

export const INDICATOR_COLORS = {
  [IPasswordStrengthIndicator.NO_PASSWORD]: 'bg-transparent', // strength 0
  [IPasswordStrengthIndicator.VERY_WEAK]: 'bg-primary-darker', // strength 1
  [IPasswordStrengthIndicator.WEAK]: 'bg-primary-dark', // strength 2
  [IPasswordStrengthIndicator.SOLID]: 'bg-warning-main', // strength 3
  [IPasswordStrengthIndicator.STRONG]: 'bg-success-light', // strength 4
  [IPasswordStrengthIndicator.VERY_STRONG]: 'bg-success-main' // strength 5
};

export const INDICATOR_TRANSLATION_KEYS = {
  [IPasswordStrengthIndicator.NO_PASSWORD]: 'noPassword', // strength 0
  [IPasswordStrengthIndicator.VERY_WEAK]: 'veryWeak', // strength 1
  [IPasswordStrengthIndicator.WEAK]: 'weak', // strength 2
  [IPasswordStrengthIndicator.SOLID]: 'solid', // strength 3
  [IPasswordStrengthIndicator.STRONG]: 'strong', // strength 4
  [IPasswordStrengthIndicator.VERY_STRONG]: 'veryStrong' // strength 5
};
